import {Box, Heading, Image, Text, VStack} from "@chakra-ui/react";
import {StyledButton} from "../../components";
import {Link} from "react-router-dom";

const NotFound = () => {

    return (
        <VStack
            gap={'16px'}
            my={'150px'}
            justifyContent={'center'}>
            <Image src={'images/404.png'}/>
            <Heading fontSize={'display.md'} color={'white'}>Sorry, page not found!</Heading>
            <Text
                textAlign={'center'}
                maxW={'600px'}
                fontSize={'body.xl'}
                color={'neutral.600'}>
                Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.
            </Text>
            <StyledButton as={Link} to={'/'} mt={'80px'} w={'184px'} h={'56px'}>
                Go to Home
            </StyledButton>
            {/*<Box*/}
            {/*    position={'absolute'}*/}
            {/*    top={'-584px'}*/}
            {/*    h={'1091px'}*/}
            {/*    width={'1440px'}*/}
            {/*    left={'240px'}*/}
            {/*    opacity={'80%'}*/}
            {/*    bg={'radial-gradient(50% 50% at 50% 50%, rgba(94, 148, 255, 0.24) 0%, rgba(49, 94, 255, 0) 100%)'}*/}
            {/*    />*/}
        </VStack>
    )
}

export default NotFound